import { CategoryColor, ContentFormat, Project } from '../api/api.ts';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassPlus } from '@fortawesome/free-solid-svg-icons';
import Panel from '../common/Panel.tsx';
import {
  gradientClassesForColor,
  hoverTextColorClassesForColor,
} from '../utils/Colors.ts';
import { ProjectHeading } from './ProjectHeading.tsx';
import { useContext } from 'react';
import { LanguageContext } from '@/common/Language.tsx';
import { ContentDisplayStyle } from '@/map/Map.tsx';
import cn from '@/utils/cn.ts';

export default function Content({
  project,
  content,
  triggerDetail,
  doiLink,
  doiLabel,
  hideHeading,
  color,
}: {
  project: Project;
  content: string;
  triggerDetail?: () => void;
  doiLink?: string;
  doiLabel?: string;
  hideHeading: boolean;
  color: CategoryColor;
}) {
  const { t } = useContext(LanguageContext);

  const hoverTextColorClasses = hoverTextColorClassesForColor(color);
  return (
    <>
      {!hideHeading && <ProjectHeading project={project} color={color} />}
      {project.contentFormat !== ContentFormat.Html &&
        content.split('\n').map((line, index) => <p key={index}>{line}</p>)}
      {project.contentFormat == ContentFormat.Html && (
        <div
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></div>
      )}
      {doiLink && (
        <a
          className={cn(
            'block',
            'my-[6px]',
            '-mx-[10px]',
            'p-[10px]',
            'rounded-[6px]',
            'bg-gray-200',
            'hover:bg-gray-300',
            'no-underline',
            'group'
          )}
          href={doiLink}
          target={'_blank'}
        >
          {t('Link to publication', 'Link zur Publikation')}:
          <div className={cn('group-hover:hidden')}>
            {doiLabel ??
              (doiLink.length <= 70
                ? doiLink
                : doiLink.substring(0, 35) + '(…)' + doiLink.substring(-35))}
          </div>
          <div className={cn('hidden', 'group-hover:block')}>
            {doiLink.length <= 70
              ? doiLink
              : doiLink.substring(0, 35) +
                '(…)' +
                doiLink.substring(doiLink.length - 35)}
          </div>
        </a>
      )}
      {triggerDetail && (
        <div className={classNames('-mt-4', 'font-[.7em]')}>
          <span
            onClick={triggerDetail}
            className={classNames('cursor-pointer', hoverTextColorClasses)}
          >
            [{t('read more', 'weiter lesen')}]
          </span>
        </div>
      )}
    </>
  );
}
